export default {
    setCookie(name, value, iDay = 1000 * 60 * 60 * 24, path = '/') {
        // 值先编码再写：原样写进去的中文、分号之类，Safari 会把 cookie 截断，
        // 读出来 JSON.parse 直接报错。getCookie 那边本来就 decodeURIComponent，两边对得上
        const encoded = encodeURIComponent(value);
        // 有过期时间
        if (iDay) {
            const oDate = new Date();
            oDate.setDate(oDate.getDate() + iDay);
            document.cookie = name + '=' + encoded + '; path=' + path + '; expires=' + oDate.toUTCString();
            // 没有过期时间
        } else {
            document.cookie = name + '=' + encoded + '; path=' + path;
        }
    },
    // user cookie 只放页面真正会读的几个字段。登录响应里还有导航树等一大堆东西，
    // 整个塞进 cookie 既会被每个请求带上，体积大了还容易出问题（导航树另存在 localStorage）
    userCookieValue(res) {
        const src = res || {};
        return JSON.stringify({
            email: src.email,
            operatorEmail: src.operatorEmail,
            area: src.area,
            verify_code: src.verify_code,
            old_user: src.old_user,
            phone: src.phone,
            itu_code: src.itu_code
        });
    },
    getCookie(name) {
        let arr, reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
        if (arr = document.cookie.match(reg)) {
            return decodeURIComponent(arr[2]);
        }
        return null;
    },

    delCookie(name) {
        const cval = this.getCookie(name);
        if (cval !== null) {
            this.setCookie(name, '', -1);
        }
    },
    inArray(v, arr) {
        let i;
        for(i in arr) {
            if(arr[i] == v) {
                return true;
            }
        }
        return false;
    },
    canTurnTo(name, user, routes) {
        if(user.operatorId > 0) {
            const routePermissionJudge = (list) => {
                return list.some(item => {
                    if (item.children && item.children.length) {
                        return routePermissionJudge(item.children)
                    } else if (item.name === name) {
                        if (item.meta && item.meta.access) {
                            return item.meta.access.indexOf('visitor') < 0
                        } else {
                            return true
                        }
                    }
                })
            }

            return routePermissionJudge(routes)
        } else {
            return true;
        }
    },
      formatTime(date, fmt) {
          var date = new Date(date);
          if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
          }
          var o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds()
          };
          for (var k in o) {
            if (new RegExp('('+k+')').test(fmt)) {
              var str = o[k] + '';
              fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
            }
          }
          return fmt;
    },
    // 当天日期 2022-04-01
    getNowFormatDate() {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    },
    formatNum(strNum){
        if(strNum.length <= 3) {
            return strNum;
        }
        if(!/^(\+|-)?(\d+)(\.\d+)?$/.test(strNum)) {
            return strNum;
        }
        var a = RegExp.$1,
            b = RegExp.$2,
            c = RegExp.$3;
        var re = new RegExp();
        re.compile("(\\d)(\\d{3})(,|$)");
        while(re.test(b)) {
            b = b.replace(re, "$1,$2$3");
        }
        return a + "" + b + "" + c;
    },
    // 处理表单参数，如果有值为空，则不传递该值
    filterParams(obj) {
        let newParams = {};
        for(let key in obj) {
            // 如果对象的属性值不为空，则保存该属性
            if(obj[key] !== null && obj[key] !== "") {
                newParams[key] = obj[key];
            }
        }
        return newParams;
    },
    // 千分位处理
    commafy(num){
        var num = (num || 0).toString(), result = '';
        while (num.length > 3) {
            result = ',' + num.slice(-3) + result;
            num = num.slice(0, num.length - 3);
        }
        if (num) { result = num + result; }
        return result;
    },
    // 过滤映射关系
    filterCloumnValue(val, list, locale) {
        const item = list.find(i => i.id === val);
        return item ? (locale === 'zh' ? item.name : item.en_name) : '';
    },
}
